import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "vld-parent" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "card-header border-0 pt-5" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "card-title align-items-start flex-column" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "card-label fw-bolder fs-3 mb-1" }, "Data Callback VA ")
  ])
], -1)
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "row align-items-start" }
const _hoisted_5 = { class: "col" }
const _hoisted_6 = { class: "fv-row mb-6 fv-plugins-icon-container fv-plugins-bootstrap5-row-valid" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2" }, "Tanggal Awal", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "fv-plugins-message-container invalid-feedback" }, null, -1)
const _hoisted_9 = { class: "col" }
const _hoisted_10 = { class: "fv-row mb-9 fv-plugins-icon-container fv-plugins-bootstrap5-row-valid" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2" }, "Tanggal Akhir", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "fv-plugins-message-container invalid-feedback" }, null, -1)
const _hoisted_13 = { class: "card-body py-3" }
const _hoisted_14 = { class: "table-responsive" }
const _hoisted_15 = { class: "table align-middle gs-0 gy-4" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "fw-bolder text-muted bg-light" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Waktu"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "No Virtual VA"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Nama"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Pembayaran"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Status")
  ])
], -1)
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { class: "text-center" }
const _hoisted_19 = { class: "text-center" }
const _hoisted_20 = { class: "text-center" }
const _hoisted_21 = { class: "text-center" }
const _hoisted_22 = { class: "text-center" }
const _hoisted_23 = { key: 1 }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", {
    colspan: "6",
    style: {"text-align":"center"}
  }, "Tidak Ada Data")
], -1)
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = { class: "row mt-5 mb-5" }
const _hoisted_27 = { class: "col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start" }
const _hoisted_28 = {
  class: "dataTables_length",
  id: "kt_customers_table_length"
}
const _hoisted_29 = ["label", "value"]
const _hoisted_30 = { class: "p-3" }
const _hoisted_31 = { class: "col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end" }
const _hoisted_32 = { class: "pagination" }
const _hoisted_33 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_loading, {
        active: _ctx.isLoading,
        "is-full-page": _ctx.fullPage,
        color: _ctx.isColor,
        "background-color": _ctx.isBackgroundColor,
        opacity: _ctx.isOpacity
      }, null, 8, ["active", "is-full-page", "color", "background-color", "opacity"])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass([_ctx.widgetClasses, "card"])
    }, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createVNode(_component_el_date_picker, {
                modelValue: _ctx.dateFrom,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.dateFrom) = $event)),
                type: "text",
                name: "dateFrom",
                onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.pilihTanggalAwal()))
              }, null, 8, ["modelValue"]),
              _hoisted_8
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              _createVNode(_component_el_date_picker, {
                modelValue: _ctx.dateUntil,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.dateUntil) = $event)),
                type: "text",
                name: "dateUntil",
                onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.pilihTanggalAkhir()))
              }, null, 8, ["modelValue"]),
              _hoisted_12
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("table", _hoisted_15, [
            _hoisted_16,
            (_ctx.tableData.length)
              ? (_openBlock(), _createElementBlock("tbody", _hoisted_17, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableData, (item, index) => {
                    return (_openBlock(), _createElementBlock("tr", { key: index }, [
                      _createElementVNode("td", _hoisted_18, _toDisplayString(_ctx.formatDate(item.createTime)), 1),
                      _createElementVNode("td", _hoisted_19, _toDisplayString(item.vaNumber), 1),
                      _createElementVNode("td", _hoisted_20, _toDisplayString(item.userName), 1),
                      _createElementVNode("td", _hoisted_21, _toDisplayString(_ctx.formatPrice(item.amount)), 1),
                      _createElementVNode("td", _hoisted_22, _toDisplayString(item.status), 1)
                    ]))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("tbody", _hoisted_23, _hoisted_25))
          ])
        ]),
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("label", null, [
                _withDirectives(_createElementVNode("select", {
                  name: "kt_customers_table_length",
                  class: "form-select form-select-sm form-select-solid",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.paging.size) = $event)),
                  placeholder: "Per page",
                  onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.changePageSize()))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paging.perPageOptions, (item) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: item,
                      label: item,
                      value: item
                    }, null, 8, _hoisted_29))
                  }), 128))
                ], 544), [
                  [_vModelSelect, _ctx.paging.size]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_30, " Showing " + _toDisplayString(_ctx.from + 1) + " to " + _toDisplayString(_ctx.to) + " of " + _toDisplayString(_ctx.paging.totalElements) + " entries ", 1)
          ]),
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("ul", _hoisted_32, [
              _createElementVNode("li", {
                class: _normalizeClass(["page-item previous", { disabled: _ctx.paging.page + 1 === 1 }])
              }, [
                _createElementVNode("a", {
                  class: "page-link",
                  style: {"cursor":"pointer"},
                  onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.prevPage && _ctx.prevPage(...args)))
                }, " Previous ")
              ], 2),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.range(1, _ctx.paging.totalPages), (item) => {
                return (_openBlock(), _createElementBlock("li", {
                  class: _normalizeClass(["page-item", { active: _ctx.paging.page + 1 === item }]),
                  key: item
                }, [
                  (Math.abs(item - _ctx.paging.page) <= 2)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        class: "page-link",
                        onClick: ($event: any) => (_ctx.changePage(item))
                      }, _toDisplayString(item), 9, _hoisted_33))
                    : _createCommentVNode("", true)
                ], 2))
              }), 128)),
              _createElementVNode("li", {
                class: _normalizeClass(["page-item next", { disabled: _ctx.paging.page + 1 === _ctx.paging.totalPages }])
              }, [
                _createElementVNode("a", {
                  class: "page-link",
                  style: {"cursor":"pointer"},
                  onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.nextPage && _ctx.nextPage(...args)))
                }, " Next ")
              ], 2)
            ])
          ])
        ])
      ])
    ], 2)
  ], 64))
}